"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingHistoryReasonEnum = void 0;
var MeetingHistoryReasonEnum;
(function (MeetingHistoryReasonEnum) {
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["created"] = 1] = "created";
  // published = 2,
  // unpublished = 3,
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["archived"] = 4] = "archived";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["removed"] = 5] = "removed";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["updated"] = 6] = "updated";
  /** "быстрая" сессия */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["quick_created"] = 7] = "quick_created";
  /** Оплаты */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["payment_created"] = 50] = "payment_created";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["payment_sent_to_user"] = 55] = "payment_sent_to_user";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["payment_request_sent"] = 60] = "payment_request_sent";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["payment_request_success"] = 61] = "payment_request_success";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["payment_request_fail"] = 62] = "payment_request_fail";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["payment_success"] = 69] = "payment_success";
  /** Выплаты */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_started"] = 70] = "checkout_started";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_check_formed"] = 73] = "checkout_check_formed";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_request_sent"] = 75] = "checkout_request_sent";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_request_success"] = 78] = "checkout_request_success";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_request_fail"] = 88] = "checkout_request_fail";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_failed"] = 97] = "checkout_failed";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_canceled"] = 98] = "checkout_canceled";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["checkout_completed"] = 99] = "checkout_completed";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["started"] = 100] = "started";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["cancel_requested"] = 101] = "cancel_requested";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["canceled"] = 102] = "canceled";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["reschedule_requested"] = 103] = "reschedule_requested";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["rescheduled"] = 104] = "rescheduled";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["finished"] = 105] = "finished";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["disrupted"] = 106] = "disrupted";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["auto_started"] = 107] = "auto_started";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["auto_finished"] = 108] = "auto_finished";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["time_extended"] = 109] = "time_extended";
  /** участник оплатил */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_invited"] = 150] = "participant_invited";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_joined"] = 151] = "participant_joined";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_leaved"] = 152] = "participant_leaved";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_accepted"] = 153] = "participant_accepted";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_declined"] = 154] = "participant_declined";
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_paid"] = 155] = "participant_paid";
  /** участник не пришёл на занятие */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_skipped"] = 156] = "participant_skipped";
  /** участник исключён */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_kicked_off"] = 157] = "participant_kicked_off";
  /** участник не оплатил  */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["reservation_expired"] = 158] = "reservation_expired";
  /** участник НЕ оплатил */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["participant_unpaid"] = 159] = "participant_unpaid";
  /** преподаватель получил вознаграждение */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["owner_rewarded"] = 200] = "owner_rewarded";
  /** преподаватель оштрафован */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["owner_fined"] = 201] = "owner_fined";
  /** преподаватель не пришёл на занятие */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["owner_skipped"] = 202] = "owner_skipped";
  /** опубликован отзыв на митинг */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["review_posted"] = 250] = "review_posted";
  /** получена жалоба на митинг */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["complaint_posted"] = 300] = "complaint_posted";
  /** жалоба на митинг решена */
  MeetingHistoryReasonEnum[MeetingHistoryReasonEnum["complaint_resolved"] = 301] = "complaint_resolved";
})(MeetingHistoryReasonEnum = exports.MeetingHistoryReasonEnum || (exports.MeetingHistoryReasonEnum = {}));
